export default class UtilityCounterBuildingRequest {
    constructor(private readonly buildingId: string) {}

    toJson(): {
        building_ids: string[];
        active: 0|1;
    } {
        return {
            building_ids: [this.buildingId],
            active: 1
        };
    }
}